<template>
  <div v-if="isLoading == false">
    <v-card>
      <v-card-title>
        <v-btn icon @click="$router.back()"><v-icon>arrow_back</v-icon></v-btn>
        <span class="ml-3 heading_1__style">Detail Minimum Price Food</span>
      </v-card-title>
      <v-card-text>
        <div class="pa-4 body__container">
          <div style="display:flex">
            <v-spacer></v-spacer>
            <span class="body_text__style"
              >Date/Time Created :
              {{
                moment(smallOrderDifferenceDetail.sod_create_at).format(
                  "DD/MM/YYYY | HH:mm น."
                )
              }}</span
            >
          </div>
          <div class="mt-1 heading_5__style">No : {{ $route.params.no }}</div>
          <div
            class="mt-3 heading_5__style"
            v-if="smallOrderDifferenceDetail.sod_district_id == 'All District'"
          >
            Selected : <span>All District</span>
          </div>
          <v-layout wrap class="mt-3 heading_5__style" align-center v-else>
            <v-flex xs12 lg1>Selected :</v-flex>

            <v-flex
              shrink
              v-for="(district,
              index) in smallOrderDifferenceDetail.sod_district_id"
              :key="index"
              class="ma-1"
              ><div class="body__tag ml-2">{{ district.district_name_th }}</div>
            </v-flex>
          </v-layout>
          <div
            class="mt-3 heading_5__style"
            v-if="smallOrderDifferenceDetail.sod_store_id == 'All Store'"
          >
            Participating Stores : All store
          </div>
          <div v-else>
            <div class="mt-3 heading_5__style">
              Participating Stores
              <span
                >({{ smallOrderDifferenceDetail.sod_store_id.length }})</span
              >
            </div>

            <div v-if="isLoadingDistrict == true" style="text-align:center">
              <span class="loader">Loading</span>
            </div>
            <div v-else>
              <v-layout
                wrap
                class="mt-3 heading_6__style"
                align-center
                v-for="(district, index) in districtList"
                :key="index"
              >
                <v-flex shrink style="white-space: nowrap"
                  >{{ district.district_name_th }}
                  <span class="ml-1" style="color:grey"
                    >({{
                      filterStoreByDistrict(district.district_id).length
                    }}):</span
                  ></v-flex
                >

                <v-flex
                  shrink
                  v-for="(store, index) in filterStoreByDistrict(
                    district.district_id
                  )"
                  :key="index"
                  class="ma-1"
                  ><div class="body__tag ml-2">{{ store.store_name_th }}</div>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <div class="mt-3 heading_5__style">
            Minimum Price Food : ฿{{
              smallOrderDifferenceDetail.sod_minimum_price
            }}
          </div>
          <v-layout wrap>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 class="text-xs-center pr-2">
              <v-btn
                class="button__style_1"
                outline
                color="error"
                @click="confirmDialog = true"
                ><span>Delete</span>
              </v-btn></v-flex
            >
            <v-flex xs12 sm2 class="text-xs-center">
              <v-btn
                class="button__style_1"
                outline
                color="info"
                @click="toEdit()"
                ><span>Edit</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirmDialog" max-width="500px"
      ><v-card style="border-radius:6px;"
        ><v-card-text
          class="py-4"
          style="display:flex;
          justify-content:center;
          align-items:center;
          flex-direction:column"
        >
          <div class="heading_5__style">
            Are you sure to delete minimum price food?
          </div>
          <div class="mt-4">
            <v-btn
              :disabled="isDelete"
              @click="confirmDialog = false"
              style="border-radius: 7px;width:150px"
              outline
              color="#EC5F59"
              ><span>Cancel</span>
            </v-btn>
            <v-btn
              :loading="isDelete"
              @click="deleteSmallOrder()"
              style="border-radius: 7px;width:150px"
              outline
              color="#67AD5B"
              ><span>Sure</span>
            </v-btn>
          </div>
        </v-card-text></v-card
      ></v-dialog
    >
    <formDialog
      :dialog="visibleForm"
      @onClosed="visibleForm = false"
      @onSaved="submitForm($event)"
      :editedIndex="1"
      :selectedItem="selectedItem"
    />
  </div>
</template>

<script>
import formDialog from "@/components/back-office/SmallOrderDifference/FormDialog.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      confirmDialog: false,
      visibleForm: false,
      smallOrderDifferenceDetail: {
        sod_store_id: [],
      },
      isLoading: false,
      selectedItem: {},
      isDelete: false,
      isEdit: false,
      districtList: [],
      isLoadingDistrict: false,
    };
  },
  components: {
    formDialog,
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      fetchSmallOrderDifferenceById:
        "fetchOrderListBack/fetchSmallOrderDifferenceById",
      updateSmallOrderDifference:
        "fetchOrderListBack/updateSmallOrderDifference",
      removeSmallOrderDifference:
        "fetchOrderListBack/removeSmallOrderDifference",
      fetchDistrictList: "fetchProvinceBack/getDistrictCore",
    }),
    moment,
    async getDistrictList() {
      if (this.smallOrderDifferenceDetail.sod_store_id == "All Store") return;
      this.isLoadingDistrict = true;
      let province = this.$route.params.province;
      let provinceItem = this.provinceData.find(
        (val) =>
          val.province_name_en.toLowerCase().replace(/ /g, "") == province
      );
      let responseList = await this.fetchDistrictList(provinceItem.province_id);

      let storeDistrictList = this.smallOrderDifferenceDetail.sod_store_id.map(
        (val) => val.district_id
      );
      this.districtList = responseList.filter((val) =>
        storeDistrictList.includes(val.district_id)
      );
      let _this = this;
      setTimeout(() => {
        _this.isLoadingDistrict = false;
      }, 1000);

      return;
    },
    async getData() {
      this.isLoading = true;
      let result = await this.fetchSmallOrderDifferenceById({
        sodId: this.$route.params.small_order_difference_id,
        province: this.$route.params.province,
      });

      this.isLoading = false;
      if (result.msg == false) return;
      this.smallOrderDifferenceDetail = result;
      await this.getDistrictList();
    },
    filterStoreByDistrict(district_id) {
      return this.smallOrderDifferenceDetail.sod_store_id.filter(
        (val) => val.district_id == district_id
      );
    },
    async deleteSmallOrder() {
      this.isDelete = true;
      let response = await this.removeSmallOrderDifference({
        sodId: this.$route.params.small_order_difference_id,
        province: this.$route.params.province,
      });
      this.isDelete = false;
      if (response == false) return;
      this.confirmDialog = false;
      this.$router.back();
    },
    toEdit() {
      this.selectedItem = JSON.parse(
        JSON.stringify(this.smallOrderDifferenceDetail)
      );
      this.visibleForm = true;
    },
    async submitForm(event) {
      if (event.form.sod_is_all_store == true) {
        event.form.sod_store_id = [];
      }
      if (event.form.sod_is_all_district == true) {
        event.form.sod_district_id = [];
      }
      let response = await this.updateSmallOrderDifference({
        payload: event.form,
        province: this.$route.params.province,
      });
      event.done();
      if (response == false) return;
      this.smallOrderDifferenceDetail = response;
      await this.getDistrictList();
      this.visibleForm = false;
    },
  },
  async created() {
    this.getData();
  },
};
</script>

<style scoped>
.body__container {
  border: 2px solid #c9c9c9;
  border-radius: 6px;
}
.body__tag {
  background: #fffced 0% 0% no-repeat padding-box;
  border: 1.5px solid #fddf00;
  border-radius: 4px;
  padding: 3px 12px;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
}

.button__style_1 {
  width: 100%;
  height: 50px;
  border-radius: 8px;
}

.button__style_1 span {
  font-weight: bold;
  font-size: 18px;
}

.body_text__style {
  font-size: 14px;
}

.heading_1__style {
  font-size: 28px;
  font-weight: bold;
}

.heading_2__style {
  font-size: 26px;
  font-weight: bold;
}

.heading_3__style {
  font-size: 24px;
  font-weight: bold;
}

.heading_4__style {
  font-size: 22px;
  font-weight: bold;
}

.heading_5__style {
  font-size: 20px;
  font-weight: bold;
}

.heading_6__style {
  font-size: 18px;
  font-weight: bold;
}

.loader {
  font-size: 48px;
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #263238;
  box-sizing: border-box;
  text-shadow: 0 0 2px grey, 0 0 1px grey, 0 0 1px grey;
  letter-spacing: 2px;
  position: relative;
}
.loader::after {
  content: "Loading";
  position: absolute;
  left: 0;
  top: 0;
  color: #fddf00;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  animation: animloader 2s linear infinite;
}

@keyframes animloader {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>
